<script setup>
import Text from '@/components/Text.vue'
</script>

<template>
  <main>
    <v-container fluid>
      <v-card class="mx-auto pa-2" max-width="900">
        <Text slot="imprint" />
      </v-card>
    </v-container>
  </main>
</template>
